import type { KpiChange } from './kpi-change.ts'

/**
 * A change is coloured by whether it is good for the household, not by its sign: net worth
 * going up is good, spending going up is bad. The arrow already carries direction, so the
 * colour is free to carry the verdict (the approved 2026-09-13 visual direction).
 */
export type Verdict = 'good' | 'bad' | 'flat'

/** Which direction is in the household's favour for this figure. */
export type Favourable = 'up' | 'down'

/**
 * A change under one percent reads as flat, so a wobble never paints a tile red or green.
 * `moneyChangeRatio`'s result is pre-scaled to a percentage at RATIO_SCALE (10), so one
 * percent is 10^10 units.
 */
const FLAT_BAND_UNITS = 10n ** 10n

export function changeVerdict(
  change: Pick<KpiChange, 'direction' | 'percent'>,
  favourable: Favourable,
): Verdict {
  if (change.direction === 0) return 'flat'
  if (change.percent !== undefined) {
    const magnitude = change.percent.units < 0n ? -change.percent.units : change.percent.units
    if (magnitude < FLAT_BAND_UNITS) return 'flat'
  }
  const rising = change.direction > 0
  return rising === (favourable === 'up') ? 'good' : 'bad'
}
